import {useState} from "react";
import {Collapse} from "antd";
import className from "classnames/bind";
import CriteriaItem from "./CriteriaItem";
import style from "../style/SeoCheck.module.scss";

const cn = className.bind(style);

/**
 * Danh sách nhóm tiêu chí + menu tĩnh (sticky) để nhảy nhanh tới từng nhóm.
 *
 * @param groups [{key, label, score, max, items:[...]}]
 * @param onHighlight callback khi click heading/ảnh (đẩy sang WebsitePreview)
 */
function CriteriaGroup({groups = [], onHighlight, hideNav = false}) {

	const [active, setActive] = useState(groups.map((g) => g.key));

	// Mở nhóm (nếu đang đóng) rồi cuộn tới tiêu đề nhóm.
	const goTo = (key) => {
		setActive((prev) => (prev.includes(key) ? prev : [...prev, key]));
		setTimeout(() => {
			const el = document.getElementById('seo-group-' + key);
			if (el) el.scrollIntoView({behavior: 'smooth', block: 'start'});
		}, 60);
	};

	const items = groups.map((g) => {
		const fails = g.items?.filter((it) => it.status !== 'pass').length || 0;

		return {
			key: g.key,
			label: (
				<div id={'seo-group-' + g.key} className={cn('group-head')}>
					<span className={cn('group-title')}>{g.label}</span>
					<span className={cn('group-meta')}>
						{fails > 0 && <em className={cn('group-warn')}>{fails} cần cải thiện</em>}
						<strong>{g.score}/{g.max}</strong>
					</span>
				</div>
			),
			children: (
				<div className={cn('group-items')}>
					{g.items?.map((it) => <CriteriaItem key={it.key} item={it} onHighlight={onHighlight} />)}
				</div>
			),
		};
	});

	return (
		<div className={cn('groups-wrap')}>
			{/* Menu tĩnh: chip mỗi nhóm + số tiêu chí cần cải thiện. Ẩn khi preview mở rộng. */}
			<nav className={cn('groups-nav', {hidden: hideNav})}>
				{groups.map((g) => {
					const fails = g.items?.filter((it) => it.status !== 'pass').length || 0;
					return (
						<button
							key={g.key}
							type="button"
							className={cn('nav-chip', {warn: fails > 0})}
							onClick={() => goTo(g.key)}
						>
							{g.label}
							{fails > 0 && <em className={cn('nav-chip-badge')}>{fails}</em>}
						</button>
					);
				})}
			</nav>

			<Collapse
				className={cn('groups')}
				activeKey={active}
				onChange={setActive}
				items={items}
			/>
		</div>
	);
}

export default CriteriaGroup;
